<template>
  <div>
    <v-progress-linear
        :active="isLoading"
        :indeterminate="isLoading"
        absolute
        top
        color="#743063"
      ></v-progress-linear>

    <v-img
      max-width="1650"
      class="mx-auto"
      :src="currentCategory.imageUrl | localized"
    ></v-img>

    <v-card class="ma-3" elevation="0">
      <v-card-text>
        <div
          v-html="currentCategory.description.arabic"
        ></div>
      </v-card-text>
    </v-card>

    <div class="text-center">
      <v-chip
        :to="`/category/${subCategory.outlineId}`"
        v-for="subCategory in currentCategory.subCategories"
        :key="subCategory.id"
        class="ma-2"
      >
        {{ subCategory.name | localized }}
      </v-chip>
    </div>

    <v-card v-if="false" flat class="mx-auto" max-width="1650">
      <v-row>
        <v-col class="d-flex" cols="12" sm="3">
          <v-select :items="sortByOptions" dense></v-select>
        </v-col>

        <v-col class="d-flex" cols="12" sm="2">
          <v-select :items="numberOfItemsPerPageOptions" dense></v-select>
        </v-col>
      </v-row>
    </v-card>

    <div class="hidden-sm-and-down">
      <v-card class="d-flex flex-wrap mx-auto my-1" flat max-width="1650">
        <ItemComponent
          v-for="item in pagedItems.items"
          :key="item.id"
          :itemProp="item"
        ></ItemComponent>
      </v-card>
    </div>
    <div class="hidden-md-and-up">
      <div class="d-flex flex-column align-center">
        <ItemComponent
          v-for="item in pagedItems.items"
          :key="item.id"
          :itemProp="item"
        ></ItemComponent>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ItemComponent from "@/components/ItemComponent";
export default {
  name: "Category",
  props: {
    outlineId: {
      type: String,
      default: "",
    },
  },
  components: {
    ItemComponent,
  },
  //********************** */
  data: () => ({
    isLoading: false,
    sortByOptions: [
      { text: "عرض المشاريع غير المكتملة أولا", value: "UncompletedFirst" },
    ],
    numberOfItemsPerPageOptions: [],
  }),

  watch: {
    $route: "loadPagedItems",
  },

  //********************** */
  computed: {
    ...mapGetters("Catalog", {
      pagedItems: "pagedItems",
      currentCategory: "currentCategory",
    }),
  },

  //********************** */
  methods: {
    loadCurrentCategory: function () {
      this.$store.dispatch("Catalog/loadCurrentCategory", this.outlineId);
    },

    loadPagedItems: async function () {
      this.isLoading = true;

      await this.$store.dispatch("Catalog/loadPagedItems", {
        categoryOutlineId: this.outlineId,
        page: 1,
        pageSize: 10,
        sortBy: "UncompletedFirst",
      });

      this.loadCurrentCategory();

      this.isLoading = false;
    },
  },

  //********************** */
  async created() {
    this.loadPagedItems();
  },
};
</script>

<style>
</style>